import Public from "layouts/Public";
import Secure from "layouts/Secure";

const routes = [
  { path: "/teachers-reports/*", name: "TeachersReport", element: <Secure /> },
  { path: "/grades-reports/*", name: "GradesReport", element: <Secure /> },
  { path: "/other-reports/*", name: "OtherReports", element: <Secure /> },
  { path: "/accounts/classes/*", name: "Accounts", element: <Secure /> },
  { path: "/accounts/teachers/*", name: "Accounts", element: <Secure /> },
  { path: "/login/*", name: "Login", element: <Public /> },
  { path: "/*", name: "Login", element: <Public /> },
];

export default routes;
